(function trackerSeoContent(global) {
  'use strict';

  /**
   * trackSeoContentLinkClickEvent: tracks the click event when some SEO link is clicked.
   * @param {object} event object result from the event triggered.
   */
  function trackSeoContentLinkClickEvent(event) {
    const seoContainer = global.document.querySelector('[data-seo-content-container]');
    if (!event || !event.target || !event.target.href || !seoContainer || !seoContainer.contains(event.target)) {
      return;
    }

    const clickedElement = event.target;
    const linkClicked = clickedElement.href;
    const elementText = clickedElement.textContent;

    const googleAnalyticsEvent = {
      eventType: 'GA4Event',
      eventName: 'search_events',
      params: {
        click_target: 'Seo Content Area',
        search_value: elementText,
        click_target1: linkClicked
      }
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: googleAnalyticsEvent
      }
    }));
  }

  global.document.addEventListener('click', trackSeoContentLinkClickEvent);
}(window));

define("trackerSeoContent", function(){});

